import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { WithinCyclePerformanceEffects } from './store/effects/within-cycle-performance.effects';
import { withinCyclePerformanceReducer } from './store/reducers/within-cycle-performance.reducer';

export function provideWithinCyclePerformanceFeature() {
  return makeEnvironmentProviders([
    provideState('within-cycle-performance', withinCyclePerformanceReducer),
    provideEffects(WithinCyclePerformanceEffects),
  ]);
}
